// @flow
import modularui from "../_modularui/ModularUIConnector";
import Href from "../../models/href/Href";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'usePanel' instead
 */
export const connectPanel: ModularUIConnector = modularui(
  "PanelRenderer",
  ({ href, match, querystring = "" }) => {
    if (!href && !match) {
      throw new Error(
        "Cannot determine panel url because of missing href and match",
      );
    }

    const panelHref = href ? new Href(href) : new Href(match.url);

    if (match && match.isExact) {
      panelHref.addParametersFromString(querystring);
    }

    return panelHref;
  },
  {
    propName: "panel",
  },
);
